import { createAction } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const AlertActionTypes = keyMirror({
  CREATE_DISMISSIBLE_ALERT: null,
  CREATE_AUTOMATIC_DISMISSIBLE_ALERT: null,
  CLEAR_ALERT: null
});
export const createDismissibleAlert = (alertMessageKey, props, helpUrl) => createAction(AlertActionTypes.CREATE_DISMISSIBLE_ALERT, {
  alertMessageKey,
  props,
  helpUrl
});
export const createAutomaticDismissibleAlert = (alertMessageKey, props) => createAction(AlertActionTypes.CREATE_AUTOMATIC_DISMISSIBLE_ALERT, {
  alertMessageKey,
  props
});
export const clearAlert = alertId => createAction(AlertActionTypes.CLEAR_ALERT, alertId);